<app-banner></app-banner>
<app-produtos-linha-index></app-produtos-linha-index>
<app-filiais-index></app-filiais-index>
<app-produto-destaque-index></app-produto-destaque-index>
<app-fornecedores-index></app-fornecedores-index>
